import axiosInstance from "../sevices/axiosInstance";

export const getUserLocation = async () => {
  //TODO: Move this to a different file after deprecating SAP
  try {
    const userLocationUrl = process.env.USER_LOCATION_URL;
    const res = await axiosInstance({
      url: userLocationUrl,
      method: "GET"
    });
    return res;
  } catch (error) {
    throw error;
  }
};
